import { Tag } from "@/components/formation";
import styles from "./scoreboard.module.scss";

interface LiveProps {
  label?: string;
  gameTime: string;
}

export default function Live({ gameTime, label = "Live" }: LiveProps) {
  return (
    <div className={styles.liveContainer}>
      <Tag intent="important">{label}</Tag>
      <span>{gameTime}</span>
    </div>
  );
}
